import { FunctionComponent } from 'react'
import styled from 'styled-components'
import Text from '../components/Text'
import Column from '../components/Column'
import Checkbox from '../components/Checkbox'
import Row from '../components/Row'
import { styles } from '../styles/themes/style'

interface IPrivateCheckBoxControlProps {
    type: string
    value: boolean
    disabled?: boolean
    onChangeHandler: (e: boolean) => void
 }

 interface IStyledRowProps {
    $disabled?: boolean
}

 const PrivateCheckBoxControl: FunctionComponent<IPrivateCheckBoxControlProps> = ({type, value, disabled, onChangeHandler}) => {
    return <StyledRow gap="8px" alignItems $disabled={disabled}>
                <Checkbox
                        $height='20px'
                        checked={value}
                        disabled={disabled}
                        onClickHandler={() => onChangeHandler(!value)}
                        checkboxId={'custom-type-checkbox'}
                        />
                <ContentColumn gap='4px'>
                    <Text $bold>{`Keep this ${type} private `}</Text>
                    <Text $lighter $paragraph3>{`Unticking the box will make the ${type} public`}</Text>
                </ContentColumn>
        </StyledRow>
}

const StyledRow = styled(Row)<IStyledRowProps>`
    width: 100%;
    align-items: flex-start;
    ${({ $disabled }) => $disabled && `
        cursor: default;
        span, &:hover span, &:focus span{
            cursor: default;
            color: ${styles.colors.disabledState};
        }
    `}
`

const ContentColumn = styled(Column)`
    flex: 1;
    min-width: 0;
    
    span {
        word-wrap: break-word;
        overflow-wrap: break-word;
        word-break: break-word;
        white-space: normal;
    }
`

export default PrivateCheckBoxControl